// Tab "Pagamentos" no detalhe do cliente (Story 4.10 AC5).
// Lista charges com status=paga/paga_manual deste cliente como proxy
// de pagamentos. Mais detalhe (Payment record) está em /charges/:id.

import { CreditCard } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { formatBR, parseLocalDate } from '@control-center/shared';

import { useCharges } from '../../hooks/use-charges';
import { chargeTypeLabel, formatAmountBR } from './charge-display';

interface ClientPaymentsTabProps {
  clientId: string;
}

export function ClientPaymentsTab({ clientId }: ClientPaymentsTabProps): JSX.Element {
  const navigate = useNavigate();

  // Pra MVP: agrega charges pagas. Cada charge tem 1 payment (1:1).
  const paidQ = useCharges({ scope: 'todas', clientId, status: 'paga', page: 1, pageSize: 50 });
  const manualQ = useCharges({
    scope: 'todas',
    clientId,
    status: 'paga_manual',
    page: 1,
    pageSize: 50,
  });

  if (paidQ.isPending || manualQ.isPending) {
    return <div className="py-8 text-center text-[13px] text-muted">Carregando…</div>;
  }

  const items = [...(paidQ.data?.data ?? []), ...(manualQ.data?.data ?? [])].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
  );

  if (items.length === 0) {
    return (
      <div className="rounded-[10px] border border-line bg-panel-2 p-12 text-center">
        <CreditCard size={24} strokeWidth={1.5} className="mx-auto mb-3 text-muted-3" />
        <p className="text-[13px] text-muted">
          Nenhum pagamento registrado pra este cliente ainda.
        </p>
      </div>
    );
  }

  return (
    <div>
      <p className="mb-3 text-[12px] text-muted">
        {items.length} {items.length === 1 ? 'pagamento' : 'pagamentos'} recebidos
      </p>
      <div className="overflow-hidden rounded-[10px] border border-line bg-panel">
        <table className="w-full text-[13px]">
          <thead className="border-b border-line bg-panel-2 text-[11px] uppercase tracking-wider text-muted-3">
            <tr>
              <th className="px-4 py-3 text-left">Cobrança</th>
              <th className="px-4 py-3 text-left">Tipo</th>
              <th className="px-4 py-3 text-right">Valor</th>
              <th className="px-4 py-3 text-left">Vencimento</th>
              <th className="px-4 py-3 text-left">Origem</th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr
                key={c.id}
                onClick={() => navigate(`/charges/${c.id}`)}
                className="cursor-pointer border-b border-line last:border-0 hover:bg-panel-2"
              >
                <td className="px-4 py-3 text-ink">{c.description}</td>
                <td className="px-4 py-3 text-muted">{chargeTypeLabel(c)}</td>
                <td className="px-4 py-3 text-right tnum text-ink">{formatAmountBR(c.amount)}</td>
                <td className="px-4 py-3 text-muted tnum">{formatBR(parseLocalDate(c.dueDate))}</td>
                <td className="px-4 py-3 text-muted">
                  {c.status === 'paga_manual' ? 'Manual (PIX/TED)' : 'Asaas'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
